var $ = require('jquery');

class BgBlackObserver {

	constructor() {
		this.useGsap = false;
		this.observer = null;
		this.scrollHandler = null;
		this.triggers = [];
	}

	create(el) {

		this.destroy(); // sécurité si recréé

		if (this.useGsap && typeof ScrollTrigger !== 'undefined') {
			this.createWithGsap(el);
		} else {
			this.createWithoutGsap(el);
		}
		this.checkBlocks(el);

	}

	destroy() {

		$('body').removeClass('has-bg-black');

		// GSAP
		if (this.triggers.length) {
			this.triggers.forEach(t => t.kill());
			this.triggers = [];
		}

		// IntersectionObserver
		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}

		// Scroll listener
		if (this.scrollHandler) {
			$(window).off('scroll.bgblack', this.scrollHandler);
			this.scrollHandler = null;
		}

	}

	/* ===================== */
	/* ===== GSAP MODE ===== */
	/* ===================== */

	createWithGsap(el) {

		gsap.registerPlugin(ScrollTrigger);

		const self = this;

		$(el).find('.bg__black').each(function () {

			const trigger = ScrollTrigger.create({
				trigger: this,
				start: 'top top',
				end: 'bottom top',

				onEnter: () => $('body').addClass('has-bg-black'),
				onLeave: () => $('body').removeClass('has-bg-black'),
				onEnterBack: () => $('body').addClass('has-bg-black'),
				onLeaveBack: () => $('body').removeClass('has-bg-black')
			});

			self.triggers.push(trigger);

		});

	}

	/* =========================== */
	/* ===== NO GSAP MODE ======== */
	/* =========================== */

	createWithoutGsap(el) {

		const self = this;

		this.scrollHandler = function () {
			self.checkBlocks(el);
		};

		this.observer = new IntersectionObserver((entries) => {

			let isVisible = false;

			entries.forEach(entry => {
				if (entry.isIntersecting) isVisible = true;
			});

			if (isVisible) {
				$(window).on('scroll.bgblack', this.scrollHandler);
				this.checkBlocks(el);
			} else {
				$(window).off('scroll.bgblack', this.scrollHandler);
				$('body').removeClass('has-bg-black');
			}

		}, {
			root: null,
			threshold: 0
		});

		$(el).find('.bg__black').each(function () {
			self.observer.observe(this);
		});

		this.checkBlocks(el);

	}

	checkBlocks(el) {

		let hasBlack = false;

		$(el).find('.bg__black').each(function () {

			const rect = this.getBoundingClientRect();
			console.log('rect', rect);

			if (rect.top <= 0 && rect.bottom > 0) {
				hasBlack = true;
			}

		});

		console.log('hasBlack', hasBlack, el);

		$('body').toggleClass('has-bg-black', hasBlack);

	}

}

const bgBlackObserver = new BgBlackObserver();

$(window).on('site:initPage', function(evt, el){
	bgBlackObserver.destroy();
	bgBlackObserver.create(el);
});